module.exports = __webpack_public_path__ + "img/ico_societa.869f0c5c.png";